import { render, staticRenderFns } from "./org-single-quotes.vue?vue&type=template&id=9368f6d0&"
import script from "./org-single-quotes.vue?vue&type=script&lang=js&"
export * from "./org-single-quotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports